import React, { type FC } from 'react';
import {
  PaymentMethodFundingSources,
  type PaymentMethodFundingSource,
  type PaymentsButtonPlace,
} from '../../../../types/PaymentsButtonViewConfig';
import { PayPal } from '../../../payment-methods/PayPal';
import { GooglePay } from '../../../payment-methods/GooglePay';
import { ApplePay } from '../../../payment-methods/ApplePay';

type PaymentButtonProps = {
  name: PaymentMethodFundingSource;
  place: PaymentsButtonPlace;
};

export const PaymentButton: FC<PaymentButtonProps> = ({ name, place }) => {
  switch (name) {
    case PaymentMethodFundingSources.ApplePay:
      return <ApplePay />;
    case PaymentMethodFundingSources.GooglePay:
      return <GooglePay place={place} />;
    case PaymentMethodFundingSources.PayPal:
    case PaymentMethodFundingSources.PayPalCredit:
    case PaymentMethodFundingSources.PayPalPayLater:
    case PaymentMethodFundingSources.PayPalVenmo:
      return <PayPal fundingSource={name} place={place} />;
    default:
      return null;
  }
};
